// extracted by mini-css-extract-plugin
module.exports =  {"viewContainer":"viewContainer_uMFbdvKk","withNoSidebar":"withNoSidebar_x9ziyxe8","pagesContainer":"pagesContainer_tdV2_agc"};